import { BillingCommentComponent } from '../../billing-comment/billing-comment-successful/billing-comment.component';
import { MapfreCardComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/wrapper-components/mapfre-card/mapfre-card.component';
import { MapfreLoadingComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-loading/mapfre-loading.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params , RouterModule } from '@angular/router';

import { StorageServiceObservablesService } from '@services/storage-service-observables/storage-service-observables.service';
import { PolicyDataService } from '@services/data-services/policy-data.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreLoadingComponent, MapfreCardComponent, BillingCommentComponent],
    selector: 'app-other-request-success',
    templateUrl: './other-request-success.component.html',
    styleUrls: ['./other-request-success.component.scss']
})
export class OtherRequestSuccessComponent implements OnInit {
    loading: boolean;
    policy: any;
    discountName: string;
    emailAddress: string;
    requestType: string;
    constructor(
        private activatedRoute: ActivatedRoute, 
        private policyDataService: PolicyDataService,
        private storageService: StorageServiceObservablesService,
    ) { }

    ngOnInit(): void {
        this.loading = true;
        this.requestType = "Other request";
        this.emailAddress = this.storageService.getUserFromStorage();
        this.activatedRoute.params.subscribe((params: Params) => {
            const policyId = params['policyid'];
            this.policyDataService.$policyDetails.subscribe((policyResponse) => {
                if (policyResponse) {
                    this.policy = policyResponse
                        .find(policyDetails => policyDetails.policynumber.policyNumber === policyId);
                    this.loading = false;
                }
            });
        });

    }
}